import classNames from 'classnames';
import React from 'react';
import { Image, Caption1Stronger, Caption1 } from '@fluentui/react-components';

import noDataImage from '../../media/no-data.png';
import { useNoDataStyles } from '../styles/no-data-styles';

export function NoDataCard({ i18n }: { i18n: any }) {
  const styles = useNoDataStyles();

  return (
    <div className={classNames('no-data-container', styles.noDataContainer)}>
      <div className={classNames('ba-no-data-image')}>
        <Image src={noDataImage} height={50} width={50} alt={i18n.getString(_TL_('No data available'))} /><br />
      </div>
      <Caption1Stronger className={styles.text}>{i18n.getString(_TL_('No data available. '))}</Caption1Stronger><br />
      <div className={classNames(styles.textContainer, 'ba-no-data-available-text')}>
        <Caption1 className={styles.text}>
          {i18n.getString(_TL_('To update the tile, select a different date range.'))}
        </Caption1>
        <Caption1 className={styles.text}>
          {i18n.getString(_TL_('If the tile remains blank, your account might have no data.'))}
        </Caption1>
      </div>
    </div>
  );
}
